import {Button} from "@mui/material";
import React from "react";
import {Link} from "react-router-dom";

export const BtnLink = (props: {Link: string, Text: React.ReactNode, variant?: 'text' | 'outlined' | 'contained'}) => {
    return <Button variant={props.variant || "contained"}>
        <Link to={props.Link} style={{ color: "inherit", textDecoration: "none" }}>{props.Text}</Link>
    </Button>;
}
